export default __webpack_public_path__ + "static/media/Hexagon.130bf88b.svg";